/**
 * Most based object for any Grimoire.js related classes.
 * @type {[type]}
 */
class IDObject {
    /**
     * Generate random string
     * @param  {number} length length of random string
     * @return {string}        generated string
     */
    static getUniqueRandom(length) {
        return Math.random().toString(36).slice(-length);
    }
    constructor() {
        this.id = IDObject.getUniqueRandom(10);
    }
    /**
     * Obtain stringfied object.
     * If this method was not overridden, this method return class name.
     * @return {string} stringfied object
     */
    toString() {
        return this.getTypeName();
    }
    /**
     * Obtain class name
     * @return {string} Class name of the instance.
     */
    getTypeName() {
        const funcNameRegex = /function (.{1,})\(/;
        const result = (funcNameRegex).exec((this).constructor.toString());
        return (result && result.length > 1) ? result[1] : "";
    }
}
export default IDObject;



// WEBPACK FOOTER //
// ./src/Base/IDObject.ts